import { useParams } from 'react-router-dom';

import { TranspilerVersionType } from './config';

export const useIsBulkTranspiledPipeline = () => {
  const params = useParams();
  return {
    isBulk: params?.version === TranspilerVersionType.v2,
    pipeline: params.pipeline as string,
    version: params.version as string
  };
};
